'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookSettings = require('@narvar/nth-hook-settings');
var layoutTree = require('./layoutTree.js');
var LayoutComponent = require('./LayoutComponent.js');
var useRem = require('./hooks/useRem.js');
var useWindowSize = require('./hooks/useWindowSize.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const DT_DEFAULT_MAX_WIDTH = '59.5rem'; // 952px
const desktopBreakPointMinWidth = 768;
function KitDynamicLayout(_ref) {
  let {
    deviceLayoutName = 'trackPageLayout',
    feature,
    transformLayout = null,
    view
  } = _ref;
  const {
    [deviceLayoutName]: deviceLayoutUntransformed
  } = nthHookSettings.useSettings();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const deviceLayout = typeof transformLayout === 'function' ? transformLayout(deviceLayoutUntransformed) : deviceLayoutUntransformed;
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  React.useEffect(() => {
    if (!deviceLayout) return;
    logEvent({
      eventType: nthHookContextAnalytics.NarvarEventTypes.PAGE_LOAD,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_KIT_DYNAMIC_LAYOUT,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_KIT_DYNAMIC_LAYOUT,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_KIT_DYNAMIC_LAYOUT,
      trackLayout: deviceLayoutName
    });
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [deviceLayoutName, deviceLayout]);
  if (!deviceLayout) return null;
  return /*#__PURE__*/React__default["default"].createElement(LayoutComponent["default"], {
    deviceLayout: deviceLayout,
    feature: feature,
    view: view
  });
}
function KitDynamicLayoutWithSettings(_ref2) {
  let {
    breakpoints = {
      [layoutTree.Devices.DESKTOP]: desktopBreakPointMinWidth / useRem.DEFAULT_REM
    },
    deviceLayoutName = 'trackPageLayout',
    ...props
  } = _ref2;
  const windowWidth = (useWindowSize["default"]({
    fixedSize: props.fixedSize
  }).width || 0) / useRem["default"]();
  const possibleDevicePerWindowWidth = () => {
    if (!windowWidth || !breakpoints) return undefined;
    return windowWidth >= breakpoints[layoutTree.Devices.DESKTOP] ? layoutTree.Devices.DESKTOP : layoutTree.Devices.MOBILE;
  };

  // The Devices fallback order here is purposefully distinct between first render and
  // useEffect updates. LayoutComponent can be SSR'd, which means it always needs to
  // have its initial layout state first be determined by userAgentDevice. Otherwise,
  // if we prefer window width first, the initial state in the render on the server
  // can be different than the initial state in the browser, leading to initial hydration problems.
  // When we're performing subsequent updates in the browser (aka, updating from
  // the useEffect hook), we want to prefer the window width.
  const getDeviceTypeForFirstRender = () => props.userAgentDevice || possibleDevicePerWindowWidth() || layoutTree.Devices.MOBILE;
  const getDeviceScreenTypeForBrowserUpdates = () => possibleDevicePerWindowWidth() || props.userAgentDevice || layoutTree.Devices.MOBILE;
  const [deviceScreenType, setDeviceScreenType] = React.useState(getDeviceTypeForFirstRender());

  // we initially want to set layout based on known device
  // type or windowWidth (if already defined, as per embeds),
  // but also allow for updating this on screen resize.
  React.useEffect(() => {
    // setLayout(deviceLayout[getDeviceTypeForUseEffectUpdates()]);
    setDeviceScreenType(getDeviceScreenTypeForBrowserUpdates());
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [windowWidth]);

  // Passing `additionalQueryProps` results in an additional settings query being fired during render
  // (PrefetchData in nth-kit-dynamic-track-page allows us to only send one settings query per page). The fix
  // for this would involve moving this deviceScreenType calculation out of this package and into
  // nth-kit-dynamic-track-page so that it is known and used in the initial query for retailer settings
  // in the PrefetchData component of nth-kit-dynamic-track-page. We're accepting this tradeoff for now
  return /*#__PURE__*/React__default["default"].createElement(nthHookSettings.SettingsProvider, {
    settingsRequested: deviceLayoutName,
    additionalQueryProps: {
      category: deviceScreenType === null || deviceScreenType === void 0 ? void 0 : deviceScreenType.toUpperCase()
    }
  }, /*#__PURE__*/React__default["default"].createElement(KitDynamicLayout, _extends__default["default"]({
    deviceLayoutName: deviceLayoutName
  }, props)));
}

exports.LayoutTree = layoutTree;
exports.useWindowSize = useWindowSize["default"];
exports.DT_DEFAULT_MAX_WIDTH = DT_DEFAULT_MAX_WIDTH;
exports["default"] = KitDynamicLayoutWithSettings;
